import { combineReducers } from 'redux';
import userReducer from '../reducers/userReducer';
import togglesReducer from '../reducers/togglesReducer';
import userCompanyReducer from '../pages/Onboarding/reducers/userCompanyReducer';
import profileReducer from '../reducers/profileReducer';
import occupationsReducer from '../reducers/occupationsReducer';
import profileStatisticReducer from '../pages/Statistics/reducers/profileStatisticsReducer';
import allProfilesReducer from '../pages/AllProfiles/reducers/allProfilesReducer';
import globalBroadcastReducer from '../reducers/globalBroadcastReducer';
import subCompaniesReducer from '../pages/Settings/reducers/subCompaniesReducer';

export default combineReducers({
    user: userReducer,
    toggles: togglesReducer,
    userCompanies: userCompanyReducer,
    profile: profileReducer,
    occupations: occupationsReducer,
    profileStatistics: profileStatisticReducer,
    allProfiles: allProfilesReducer,
    globalBroadcast: globalBroadcastReducer,
    subCompanies: subCompaniesReducer,
});
